/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Auth } from 'app/scripts/db/Auth';
import { EmojiUploaderView } from 'app/scripts/views/internal/autocomplete/EmojiUploaderView';
import { getKey, Key } from '@trello/keybindings';
import { Util } from 'app/scripts/lib/util';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import { templates } from 'app/scripts/views/internal/templates';
import { Analytics } from '@trello/atlassian-analytics';
import { l } from 'app/scripts/lib/localize';
import popoverEmojiCompleter from 'app/scripts/views/templates/popover_emoji_completer';
import { dontUpsell } from '@trello/browser';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { TrelloEmojiPicker } from 'app/scripts/views/emoji/TrelloEmojiPicker';
import { emojiProvider } from 'app/src/components/Emoji/EmojiProvider';
import NimbleEmoji from 'emoji-mart/dist-es/components/emoji/nimble-emoji';
import SelectEmoji from 'app/scripts/views/templates/select_emoji';

class EmojiMartCompleterView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'emoji';
    this.prototype.displayType = 'mod-reaction-selector';

    this.prototype.events = {
      'mouseenter .js-select-emoji': 'hoverItem',
      'click .js-select-emoji': 'selectEmoji',
      keydown: 'keydownEvent',
      'keyup .js-filter-emoji': 'keyupEvent',
      'click .js-upload-emoji': 'openEmojiUploader',
    };
  }

  initialize() {
    this._customEmoji = {};
    if (
      Auth.me().hasPremiumFeature('customEmoji') ||
      this.options.card
        ?.getBoard()
        ?.getOrganization()
        ?.hasPremiumFeature('customEmoji')
    ) {
      Auth.me().loadCustomEmojis();
      this.listenTo(
        Auth.me().customEmojiList,
        'change add remove reset',
        this.updateCustomEmoji,
      );
      this.updateCustomEmoji();
    }
  }

  render() {
    const data = {};

    if (this.options.input) {
      data.input = true;
    }

    data.upsellEnabled =
      !dontUpsell() ||
      Auth.me().hasPremiumFeature('customEmoji') ||
      this.options.card
        ?.getBoard()
        ?.getOrganization()
        ?.hasPremiumFeature('customEmoji');

    if (this.options.button) {
      // render the picker within the popover we selected for it
      ReactDOM.render(this.getEmojiPicker(), this.$el[0]);
    } else {
      this.$el.html(popoverEmojiCompleter(data));
      this.$emojiList = $('.js-available-emoji', this.$el);
      this.filterEmoji(this.getInput());
    }

    return this;
  }

  keyupEvent(e) {
    const key = getKey(e);

    if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$emojiList, '.item', key);
      return;
    } else if ([Key.Enter, Key.Tab].includes(key)) {
      return;
    }

    const input = this.getInput();
    return this.filterEmoji(input);
  }

  keydownEvent(e) {
    let needle;
    if (((needle = getKey(e)), [Key.Enter, Key.Tab].includes(needle))) {
      stopPropagationAndPreventDefault(e);
      // eslint-disable-next-line @trello/enforce-variable-case
      const $item = this.$emojiList.find(
        '.item.selected:first .js-select-emoji',
      );
      if ($item.length > 0) {
        return $item.click();
      }
    }
  }

  updateCustomEmoji() {
    this._customEmoji = _.object(
      Auth.me().customEmojiList.map((e) => [e.get('name'), e.get('url')]),
    );
    return this.render();
  }

  getTextInput() {
    return $(this.options.target);
  }

  getInput() {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = this.getTextInput();
    const word = Util.getWordFromCaret($textInput);
    return word.str.substring(1);
  }

  filterEmoji(input) {
    this.clearEmojiList();
    if (this.fillEmojiList(input)) {
      return Util.selectMenuItem(
        this.$emojiList,
        '.item',
        this.$emojiList.find('.item').first(),
      );
    }
  }

  renderEmojiList(list) {
    for (const e of Array.from(list)) {
      const emojiMartMarkup = NimbleEmoji({
        data: emojiProvider.getDataSync(),
        backgroundImageFn: emojiProvider.getSpritesheetsUrl,
        html: true,
        emoji: e,
        set: emojiProvider.getDefaultEmojiSet(),
        size: 18,
      });

      const data = {
        html: this._customEmoji[e] === undefined ? emojiMartMarkup : null,
        isEmojiMart: true,
        name: e,
        image: this._customEmoji[e] ?? null,
      };

      this.$emojiList.append(templates.fill(SelectEmoji, data));
    }

    return this;
  }

  fillEmojiList(input) {
    let validatedInput = input.replace(/\W+/g, '');

    if (/[A-Z]/.test(validatedInput) && this.options.input) {
      PopOver.hide();
      return false;
    }

    validatedInput = validatedInput.toLowerCase();

    $('.js-upload-emoji', this.$el)
      .text(l('upload emoji named', { emojiName: validatedInput }))
      .attr('data-emojiname', validatedInput);

    $('.js-no-matching-emoji-helper', this.$el).text(
      l('no matching emoji helper', { emojiName: validatedInput }),
    );

    const emojiMatches = this.getEmojiSuggestions(validatedInput).slice(0, 6);

    if (emojiMatches.length > 0) {
      $('.js-results', this.$el).removeClass('hide');
      $('.js-no-results', this.$el).addClass('hide');

      this.renderEmojiList(emojiMatches);
    } else {
      $('.js-results', this.$el).addClass('hide');
      $('.js-no-results', this.$el).removeClass('hide');
    }

    return emojiMatches.length !== 0;
  }

  clearEmojiList() {
    return this.$emojiList.empty();
  }

  getEmojiSuggestions(text) {
    const regex = new RegExp(`^${Util.escapeForRegex(text)}`);
    const customMatches = Object.keys(this._customEmoji).filter((e) =>
      regex.test(e),
    );

    const standardMatches = emojiProvider.emojiIndex
      .search(text)
      .map((o) => o.id);

    // We _.uniq because custom matches override standard matches
    return _.uniq([
      ...Array.from(customMatches),
      ...Array.from(standardMatches),
    ]);
  }

  hoverItem(e) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $elem = $(e.target).closest('.item');
    return Util.selectMenuItem(this.$emojiList, '.item', $elem);
  }

  selectEmoji(e, emojiName) {
    stopPropagationAndPreventDefault(e);
    if (typeof emojiName === 'string') {
      this.insertEmoji(emojiName);
    } else {
      // we need to play nicely with both jquery and React here

      // any custom emoji matches get passed as HTML attributes
      const emojiString = $(e.target)
        .closest('.js-select-emoji')
        .find('.emoji-name')
        .text();

      // we search for any best results from emoji mart
      const emojiMartMatch = emojiProvider.emojiIndex
        .search(emojiString)
        .map((o) => o.id);

      // use custom emoji, if found, or the first result from emoji mart search
      this.insertEmoji(emojiString || (emojiMartMatch && emojiMartMatch[0]));
    }
    PopOver.hide();
  }

  insertEmoji(name) {
    let word;
    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = this.getTextInput();
    if (this.options.input) {
      word = Util.getWordFromCaret($textInput);
    } else {
      const caretPosition = Util.getCaretPosition($textInput);
      if (caretPosition != null) {
        word = {
          start: caretPosition,
          end: caretPosition,
        };
      }
    }

    Util.insertSelection(
      $textInput,
      `:${`${name}`.trim()}: `,
      word != null ? word.start : undefined,
      word != null ? word.end : undefined,
    );

    return Analytics.sendUIEvent({
      action: 'selected',
      actionSubject: 'emoji',
      source: 'emojiCompleterInlineDialog',
      attributes: {
        emojiName: name,
      },
    });
  }

  openEmojiUploader(e) {
    stopPropagationAndPreventDefault(e);

    const emojiName = $(e.target, this.$el).attr('data-emojiname');

    PopOver.pushView({
      keepEdits: true,
      view: EmojiUploaderView,
      options: {
        model: Auth.me(),
        emojiName,
        completerView: this,
        card: this.options.card,
      },
    });

    Analytics.sendUIEvent({
      action: 'opened',
      actionSubject: 'inlineDialog',
      actionSubjectId: 'customEmojiUploaderInlineDialog',
      source: 'cardDetailScreen',
    });
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.$el[0]);
    return super.remove(...arguments);
  }

  getEmojiPicker() {
    const customEmojiEnabled =
      !dontUpsell() ||
      Auth.me().hasPremiumFeature('customEmoji') ||
      this.options.card
        ?.getBoard()
        ?.getOrganization()
        ?.hasPremiumFeature('customEmoji');

    // https://github.com/missive/emoji-mart#custom-emojis
    const custom = Auth.me().customEmojiList.map((e) => ({
      name: e.get('name'),
      short_names: [e.get('name')],
      imageUrl: e.get('url'),
    }));

    return (
      <TrelloEmojiPicker
        custom={custom}
        // eslint-disable-next-line react/jsx-no-bind
        onClick={(emoji, e) => this.selectEmoji(e, emoji.id)}
        showCustomEmojiButton={customEmojiEnabled}
        // eslint-disable-next-line react/jsx-no-bind
        onCustomEmojiButtonClick={this.openEmojiUploader.bind(this)}
      />
    );
  }

  willBePopped() {
    $(document).off(
      'click',
      '.emoji-mart, .emoji-mart-anchor, .emoji-mart-skin-swatch-selected, .emoji-mart-skin-swatches-opened .emoji-mart-skin',
    );
    return $(document).off('input', '.emoji-mart-search input');
  }
}

EmojiMartCompleterView.initClass();
export { EmojiMartCompleterView };
